import { render, staticRenderFns } from "./DeviceHintsTab.vue?vue&type=template&id=5cd3ad28&scoped=true&"
import script from "./DeviceHintsTab.vue?vue&type=script&lang=ts&"
export * from "./DeviceHintsTab.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceHintsTab.vue?vue&type=style&index=0&id=5cd3ad28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3ad28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCheckbox,VIcon,VProgressCircular})
